import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import styled, { css } from 'styled-components';
import { TileContext } from '../context/TileContext';
const flushMixin = css(["padding-left:0;padding-right:0;"]);
const TileSection = styled.div.withConfig({
  displayName: "UITileSection__TileSection",
  componentId: "i78e8q-0"
})(["padding:", ";", " .private-tile__section + &{padding-top:0;}"], ({
  compact
}) => compact ? '20px' : '32px', ({
  flush
}) => flush && flushMixin);
export default function UITileSection(_ref) {
  let {
    className
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["className"]);

  const {
    compact
  } = useContext(TileContext);
  return /*#__PURE__*/_jsx(TileSection, Object.assign({}, rest, {
    className: classNames("private-tile__section has--vertical-spacing", className),
    compact: compact
  }));
}
UITileSection.defaultProps = {
  flush: false
};
UITileSection.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool
};
UITileSection.displayName = 'UITileSection';